var PointCloudPointShape;(function(o){o["DISC"]="DISC";o["SPHERE"]="SPHERE"})(PointCloudPointShape||(PointCloudPointShape={}));export{PointCloudPointShape};